"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.track = track;
exports.keyValue = keyValue;
exports.register = register;
exports.registerOnce = registerOnce;
exports.deRegister = deRegister;
exports.setUser = setUser;
exports.clearUser = clearUser;
exports.flush = flush;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));

var _configuration = require("./configuration");

function track(eventBluePrint) {
  if (window.TRAAC.track) {
    window.TRAAC.track(eventBluePrint);
  } else {
    _configuration.TRAAC_CONFIG.teq.push(eventBluePrint);
  }
}

function keyValue(eventName, properties) {
  if (window.TRAAC.keyValue) {
    return window.TRAAC.keyValue(eventName, properties);
  }

  throw new Error('TRAAC is not loaded yet');
}

function register(newSuperProps) {
  var once = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (window.TRAAC.register) {
    return window.TRAAC.register(newSuperProps, once);
  }

  _configuration.TRAAC_CONFIG.teq.push({
    method: 'register',
    p1: newSuperProps,
    p2: once
  });
}

function registerOnce(newSuperProps) {
  return register(newSuperProps, true);
}

function deRegister(key) {
  if (window.TRAAC.deRegister) {
    return window.TRAAC.deRegister(key);
  }

  _configuration.TRAAC_CONFIG.teq.push({
    method: 'deRegister',
    p1: key
  });
}

function setUser(user) {
  if (window.TRAAC.setUser) {
    return window.TRAAC.setUser(user);
  }

  _configuration.TRAAC_CONFIG.teq.push({
    method: 'setUser',
    p1: user
  });
}

function clearUser() {
  if (window.TRAAC.clearUser) {
    return window.TRAAC.clearUser();
  }

  _configuration.TRAAC_CONFIG.teq.push({
    method: 'clearUser'
  });
}

function flush(timeout) {
  return new _promise.default(function (resolve, reject) {
    var callback = function callback(error, response) {
      if (error) {
        reject(error);
      } else {
        resolve(response);
      }
    };

    if (window.TRAAC.flush) {
      return window.TRAAC.flush(callback, timeout);
    }

    _configuration.TRAAC_CONFIG.teq.push({
      method: 'method',
      p1: callback,
      p2: timeout
    });
  });
}
